import { render, staticRenderFns } from "./guia-grid.vue?vue&type=template&id=aa2dd7e4"
import script from "./guia-grid.vue?vue&type=script&lang=js"
export * from "./guia-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDataTable,
})
